<template>
  <div>
    <div class="mapStyle" :id="settings.name" :style="settings.style">
      <v-row
        v-if="settings.controls.zoomControls"
        class="zoomControls flex-sm-row"
      >
        <v-col class="pa-0 d-flex align-content-start">
          <v-card class="divBehindButtons align-self-start">
            <v-card class="zoomControlCard v-card--flat">
              <p
                class="zoomControlPelement"
                style="margin-bottom: 0"
                @click="changeZoom('zoomIn')"
              >
                <v-icon class="filterIcon" color="black" small>add </v-icon>
              </p>
            </v-card>
            <v-divider></v-divider>
            <v-card class="zoomControlCard v-card--flat">
              <p
                class="zoomControlPelement"
                style="margin-bottom: 0"
                @click="changeZoom('zoomOut')"
              >
                <v-icon class="filterIcon" color="black" small>remove </v-icon>
              </p>
            </v-card>
          </v-card>
        </v-col>
        <v-card
          style="height: 50%; margin: 0 8px; max-width: 233px; min-width: 150px"
        >
          <v-slider
            style="margin: 0 1em !important; height: 2em"
            v-model="zoomLevel"
            :min="appConfigObject.map.minZoom"
            :max="appConfigObject.map.maxZoom"
            @change="zoomSlider()"
            :step="
              (appConfigObject.map.maxZoom - appConfigObject.map.minZoom) / 100
            "
            color="black"
            track-color="grey"
          ></v-slider>
        </v-card>
      </v-row>
      <v-col v-if="settings.controls.filterOption" class="filterOverlay pa-0">
        <v-menu :close-on-content-click="false" offset-y class="filterBtn">
          <template v-slot:activator="{ on }">
            <v-card class="zoomControlCard" v-on="on">
              <p class="zoomControlPelement" style="margin-bottom: 0">
                <v-icon small class="filterIcon" color="black">sort </v-icon>
              </p>
            </v-card>
          </template>
          <v-treeview
            style="background-color: white"
            @input="fireFilterMarkers"
            v-model="selectedFilters"
            hoverable
            :items="filterOptions.FilterList"
            item-text="Name"
            item-children="SubCategories"
            selectable
            selection-type="leaf"
            expand-icon="keyboard_arrow_down"
            on-icon="toggle_on"
            off-icon="toggle_off"
            return-object
            indeterminate-icon="toggle_on"
          ></v-treeview>
        </v-menu>
      </v-col>
      <v-flex class="mapAttributionOverlay" d-flex xs4 v-if="!sideBar">
        <a
          href="https://www.openstreetmap.org/copyright"
          target="_blank"
          class="hrefMap"
          >&copy; OpenStreetMap contributors</a
        >
      </v-flex>
      <transition
        name="midCircleAnimation"
        enter-active-class="animated slideInRight faster"
        leave-active-class="animated slideOutRight faster"
      >
        <v-layout fill-height v-if="sideBar" class="sideBar hidden-sm-and-down">
          <v-card
            width="400"
            max-height="38em"
            class="overflow-x-hidden overflow-y-auto"
          >
            <v-img
              min-width="200"
              max-width="400"
              max-height="200"
              :src="locationDetails.PictureURL"
            >
              <v-btn dark class="ma-2" @click="sideBar = false">
                <v-icon medium size="20"> ti-close </v-icon>
              </v-btn>
            </v-img>

            <v-card-title>{{ locationDetails.Name }}</v-card-title>

            <v-card-text>
              <v-row align="center" class="mx-0">
                <div class="dark-grey--text ml-4">
                  {{ locationDetails.Description }}
                </div>
              </v-row>

              <div class="my-4 subtitle-1">
                <v-flex xs12 v-if="locationDetails.Email !== ''">
                  <b>{{ $translate('EMAIL') }}:</b>
                  <a :href="'mailto:' + locationDetails.Email">
                    {{ locationDetails.Email }}
                  </a>
                </v-flex>
              </div>
              <div class="my-4 subtitle-1">
                <v-flex xs12 v-if="locationDetails.Website !== ''">
                  <b>{{ $translate('VRI_WEBSITE') }}:</b>
                  <a :href="locationDetails.Website">
                    {{ locationDetails.Website }}
                  </a>
                </v-flex>
              </div>
              <div class="my-4 subtitle-1">
                <v-flex xs12 v-if="locationDetails.OpeningHours !== ''">
                  <b>{{ $translate('OPEN_HOURS') }}:</b>
                  {{ locationDetails.OpeningHours }}
                </v-flex>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-flex xs12 v-if="locationDetails.PartnerLevel === 3" class="pl-3">
              <v-list two-line>
                <template v-for="(item, index) in locationDetails.Events">
                  <v-list-item
                    :key="item.title"
                    avatar
                    @click="goTo(item.EventId)"
                  >
                    <v-list-item-avatar>
                      <img :src="item.ThumbnailPicture" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.Name }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon> keyboard_arrow_right </v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list>
            </v-flex>
          </v-card>
        </v-layout>
      </transition>
      <v-dialog
        v-if="$vuetify.breakpoint.smAndDown"
        v-model="sideBar"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <v-card tile>
          <v-img max-height="250" :src="locationDetails.PictureURL">
            <v-btn dark class="ma-2" @click="sideBar = false">
              <v-icon medium size="20"> ti-close </v-icon>
            </v-btn>
          </v-img>

          <v-card-title>{{ locationDetails.Name }}</v-card-title>

          <v-card-text>
            <v-row align="center" class="mx-0">
              <div class="dark-grey--text ml-4">
                {{ locationDetails.Description }}
              </div>
            </v-row>

            <div class="my-4 subtitle-1">
              <v-flex xs12 v-if="locationDetails.Email !== ''">
                <b>{{ $translate('EMAIL') }}:</b>
                <a :href="'mailto:' + locationDetails.Email">
                  {{ locationDetails.Email }}
                </a>
              </v-flex>
            </div>
            <div class="my-4 subtitle-1">
              <v-flex xs12 v-if="locationDetails.Website !== ''">
                <b>{{ $translate('VRI_WEBSITE') }}:</b>
                <a :href="locationDetails.Website">
                  {{ locationDetails.Website }}
                </a>
              </v-flex>
            </div>
            <div class="my-4 subtitle-1">
              <v-flex xs12 v-if="locationDetails.OpeningHours !== ''">
                <b>{{ $translate('OPEN_HOURS') }}:</b>
                {{ locationDetails.OpeningHours }}
              </v-flex>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card
            scrollable
            v-if="locationDetails.PartnerLevel === 3"
            class="pl-3"
          >
            <template v-for="(item, index) in locationDetails.Events">
              <v-list-item
                :key="item.title"
                avatar
                @click="goTo(item.EventId)"
                two-line
              >
                <v-list-item-avatar>
                  <v-img :src="item.ThumbnailPicture"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.Name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon> keyboard_arrow_right </v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-card>
        </v-card>
      </v-dialog>
      <transition
        name="midCircleAnimation"
        enter-active-class="animated fadeIn faster"
        leave-active-class="animated fadeOut faster"
      >
        <v-flex class="bottomPopup" d-flex v-if="bottomPopup">
          <v-card>
            <v-row>
              <v-col class="ma-1">
                <v-img
                  :src="locationDetails.PictureURL"
                  max-height="64"
                  max-width="96"
                  min-height="64"
                  min-width="96"
                >
                </v-img>
              </v-col>
              <v-col class="ma-1" justify="center">
                <h3>{{ locationDetails.Name }}</h3>
                <p v-if="locationDetails.Description.length < 80">
                  {{ locationDetails.Description }}
                </p>
              </v-col>
            </v-row>
            <p
              class="line-clamp"
              style="margin: 4px"
              v-if="locationDetails.Description.length > 80"
            >
              {{ locationDetails.Description }}
            </p>
          </v-card>
        </v-flex>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MapObject from '../../../objects/MapObject';
import appConfig from '../../../../config/app_config';

export default {
  name: 'Map',
  data() {
    return {
      slider: 45,
      zoomLevel: 18,
      map: {},
      appConfigObject: appConfig,
      filterMenu: false,
      filterOptions: [],
      selectedFilters: [],
      bottomPopup: false,
      sideBar: false,
      locationDetails: {},
    };
  },
  computed: {
    ...mapGetters({
      _getFiltersForMap: 'locations/getFiltersForMap',
    }),
  },
  watch: {
    _getFiltersForMap(newV, oldV) {
      if (newV !== oldV) {
        this.filterOptions = newV;
      }
    },
  },
  props: {
    settings: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  created() {
    window.EventBus.listen('showBottomPopup', this.showBottomPopup);
    window.EventBus.listen('showSideBar', this.showSideBar);
  },
  mounted() {
    this.init();
    if (this.$store.getters['locations/getCenterPointForMap'].length !== 0) {
      this.map._updateCenterPoint(
        this.$store.getters['locations/getCenterPointForMap']
      );
    } else {
      this.map._updateCenterPoint(appConfig.map.center);
    }
  },
  methods: {
    init() {
      this.map = new MapObject(this.settings);
      setTimeout(() => {
        this.zoomLevel = this.map.map.getView().getZoom();
      }, 100);
      setTimeout(() => {
        const self = this;
        this.map.map.on('moveend', function () {
          self.zoomLevel = self.map.map.getView().getZoom();
        });
      }, 1000);
      // give a signal to the parent that the map is done
      this.$emit('readyToInitializeMap');
    },
    showBottomPopup(locationDetails) {
      this.sideBar = false;
      this.locationDetails = locationDetails;
      this.bottomPopup = true;
    },
    showSideBar(locationDetails) {
      this.bottomPopup = false;
      this.locationDetails = locationDetails;
      this.sideBar = true;
    },
    fireFilterMarkers() {
      if (this.selectedFilters.length > 0) {
        this.$emit('get-locations', {
          FilterId: this.filterOptions.FilterId,
          FilterList: this.selectedFilters.map((a) => a.InterestId),
        });
      } else this.$emit('get-locations');
    },
    changeZoom(zoomType) {
      const view = this.map.map.getView();
      let zoom = view.getZoom();
      if (zoomType === 'zoomOut') {
        zoom -= 1;
      } else {
        zoom += 1;
      }
      view.animate({
        zoom,
        duration: 200,
      });
    },
    goTo(EventId) {
      this.$router.push({
        path: '/' + this.$store.getters.getRegion + '/' + 'event=' + EventId,
      });
    },
    zoomSlider() {
      const view = this.map.map.getView();
      view.animate({
        zoom: this.zoomLevel,
        duration: 200,
      });
    },
  },
  beforeDestroy() {
    window.EventBus.removeListener('showBottomPopup', this.showBottomPopup);
    window.EventBus.removeListener('showSideBar', this.showSideBar);
    this.map.selfDestruct();
    this.map = null;
  },
};
</script>

<style scoped lang="scss">
.mapStyle {
  background-color: #acd3de;
  position: relative;
  bottom: 0;
}
.mapStyle div {
  width: auto;
  height: auto;
  border-radius: 10px;
}
.mapStyle .filterOverlay {
  z-index: 2;
  position: absolute;
  top: 90px;
  left: 0;
  min-height: 28px;
  max-height: 28px;
  clear: both;
  color: black;
  margin-left: 8px;
  border: none;
  cursor: pointer;
}
.zoomControlCard {
  max-width: 28px;
  min-width: 28px;
}
.mapStyle .zoomControls {
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  clear: both;
  color: black;
  margin-left: 8px;
  margin-top: 8px;
  border: none;
  cursor: pointer;
}
.mapStyle .mapAttributionOverlay {
  z-index: 2;
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: calc(1%);
  clear: both;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bottomPopup {
  z-index: 2;
  animation-duration: 200ms;
  position: absolute;
  bottom: 0;
  margin-bottom: calc(1%);
  left: calc(50% - 190px);
  right: calc(50% - 190px);
  width: 380px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hrefMap {
  font-size: 10px;
  color: black;
  text-align: end;
}
.filterDialog {
  max-height: calc(50vh - 100px) !important;
  overflow-y: auto;
  overflow-x: hidden;
}
.zoomControlPelement {
  padding: 6px;
  margin-bottom: 0px;
  text-align: center;
}
.divBehindButtons {
  max-width: 28px;
  background-color: white;
}
.sideBar {
  animation-duration: 200ms;
  width: 400px;
  height: 100% !important;
  min-width: 400px;
  z-index: 2;
  position: absolute;
  top: 0;
  margin-bottom: calc(1%);
  right: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 0 !important;
}
.sideBar div {
  border-radius: 0 !important;
}
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
